import { render, staticRenderFns } from "./statisticsPopup.vue?vue&type=template&id=2c58b20d&scoped=true&"
import script from "./statisticsPopup.vue?vue&type=script&lang=js&"
export * from "./statisticsPopup.vue?vue&type=script&lang=js&"
import style0 from "./statisticsPopup.vue?vue&type=style&index=0&id=2c58b20d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58b20d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c58b20d')) {
      api.createRecord('2c58b20d', component.options)
    } else {
      api.reload('2c58b20d', component.options)
    }
    module.hot.accept("./statisticsPopup.vue?vue&type=template&id=2c58b20d&scoped=true&", function () {
      api.rerender('2c58b20d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commodityBoard/statisticsPopup.vue"
export default component.exports